export const toggleObjectInArray = (
  array = [],
  object: any = {},
  property = ""
) => {
  const arrayClone: any = [...array];
  const index = arrayClone.findIndex(
    (item: any) => item[property] === object[property]
  );

  if (index !== -1) {
    arrayClone.splice(index, 1);
  } else {
    arrayClone.push(object);
  }

  return arrayClone;
};
